import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-12 text-center text-[#5c6861]">Chargement…</div>;
  if (!user) return <Navigate to="/connexion" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role) && !(roles.includes("teacher") && user.is_teacher)) return <Navigate to="/" replace />;
  return children;
}
